import type { ApiErrorIssue } from '@wundo/client/api.ts';
import type { JourneyIssueCode } from '@wundo/shared/journey.ts';
import { JOURNEY_TYPE_FORM_LABELS } from './journeyLabels.ts';

/* What the form cannot know before sending: it takes the database to tell. */
const JOURNEY_ISSUE_MESSAGES: Record<JourneyIssueCode, string> = {
  name_taken: 'There is already a journey type with that name',
  journey_type_outside_organisation: "Choose one of this organisation's journey types",
  manager_outside_organisation: 'Choose someone from this organisation',
  template_outside_organisation:
    "Choose one of this organisation's own conversation types",
  template_not_one_on_one: 'A journey step follows a 1:1 conversation type',
  offset_before_previous: JOURNEY_TYPE_FORM_LABELS.errors.offsetBeforePrevious,
  step_outside_type:
    'A step no longer belongs to this journey type. Reload and try again.',
  step_count_locked: JOURNEY_TYPE_FORM_LABELS.stepCountLocked,
};

/*
 * The forms check the same bounds before sending, so this only speaks when
 * the two disagree; a plain sentence with the bound beats a silent failure.
 */
export function refusalIssueMessage(issue: ApiErrorIssue): string {
  if (Object.hasOwn(JOURNEY_ISSUE_MESSAGES, issue.code)) {
    return JOURNEY_ISSUE_MESSAGES[issue.code as JourneyIssueCode];
  }
  if (issue.code === 'too_big' && issue.maximum !== undefined) {
    return `At most ${issue.maximum}`;
  }
  if (issue.code === 'too_small' && issue.minimum !== undefined) {
    return `At least ${issue.minimum}`;
  }
  return 'This value is not accepted';
}
